/**
 * Maps skill display names (from API) to translation keys.
 * Used for localizing skill options in browse filters.
 */
export const SKILLS_KEYS = {
  'Accounting/Auditing': 'accountingAuditing',
  Administrative: 'administrative',
  Advertising: 'advertising',
  Analyst: 'analyst',
  'Art/Creative': 'artCreative',
  'Business Development': 'businessDevelopment',
  Consulting: 'consulting',
  'Customer Service': 'customerService',
  Design: 'design',
  Distribution: 'distribution',
  Education: 'education',
  Finance: 'finance',
  'General Business': 'generalBusiness',
  'Health Care Provider': 'healthCareProvider',
  'Human Resources': 'humanResources',
  Legal: 'legal',
  Management: 'management',
  Manufacturing: 'manufacturing',
  Marketing: 'marketing',
  Production: 'production',
  'Product Management': 'productManagement',
  'Project Management': 'projectManagement',
  'Public Relations': 'publicRelations',
  Purchasing: 'purchasing',
  'Quality Assurance': 'qualityAssurance',
  Research: 'research',
  Sales: 'sales',
  'Software Development': 'softwareDevelopment',
  Science: 'science',
  'Strategy/Planning': 'strategyPlanning',
  'Supply Chain': 'supplyChain',
  Training: 'training',
  'Writing/Editing': 'writingEditing',
  Engineering: 'engineering',
  'Information Technology': 'informationTechnology',
  Logistics: 'logistics',
  'Attention to Detail': 'attentionToDetail',
  'Creative Logic': 'creativeLogic',
  Clojure: 'clojure',
  Mariadb: 'mariadb',
  Bigquery: 'bigquery',
  'Pair programming': 'pairProgramming',
  'Ember.js': 'ember.js',
  Webrtc: 'webrtc',
  'D3.js': 'd3.js',
  'Chrome extensions': 'chromeExtensions',
  'Third party apis': 'thirdPartyApis',
  Graphql: 'graphql',
  'Tdd::Test-driven development': 'tddTestDrivenDevelopment',
  React: 'react',
  Angularjs: 'angularjs',
  Aws: 'aws',
  'Go::Golang': 'goGolang',
  Git: 'git',
  Swift: 'swift',
  Github: 'github',
  'Ios - swift': 'iosSwift',
  Javascript: 'javascript',
  'React native': 'reactNative',
  Typescript: 'typescript',
  'Javascript es6': 'javascriptEs6',
  'Api integrations': 'apiIntegrations',
  'Tech lead': 'techLead',
  Mysql: 'mysql',
  Flask: 'flask',
  'Aws lambda': 'awsLambda',
  'Rest::Restful apis': 'restRestfulApis',
  Android: 'android',
  'Ios development': 'iosDevelopment',
  Ajax: 'ajax',
  'Web api': 'webApi',
  'Google cloud platform': 'googleCloudPlatform',
  Json: 'json',
  'Node.js': 'node.js',
  Flutter: 'flutter',
  Figma: 'figma',
  'Amazon kinesis': 'amazonKinesis',
  Gcp: 'gcp',
  'Amazon firehose': 'amazonFirehose',
  Azure: 'azure',
  'Android::Kotlin': 'androidKotlin',
  Docker: 'docker',
  Kotlin: 'kotlin',
  'C#': 'c#',
  '.net': '.net',
  'Web services': 'webServices',
  Angular: 'angular',
  Sql: 'sql',
  'Javascript frameworks': 'javascriptFrameworks',
  Xml: 'xml',
  'Ci::Cd': 'ciCd',
  Java: 'java',
  Microservices: 'microservices',
  Dynamodb: 'dynamodb',
  Less: 'less',
  Sass: 'sass',
  'Apollo client': 'apolloClient',
  'Apollo server': 'apolloServer',
  Kubernetes: 'kubernetes',
  Cloud: 'cloud',
  'Nest.js': 'nest.js',
  'Vue.js': 'vue.js',
  Jquery: 'jquery',
  Solidity: 'solidity',
  Devops: 'devops',
  Fintech: 'fintech',
  Terraform: 'terraform',
  Ansible: 'ansible',
  Chef: 'chef',
  Puppet: 'puppet',
  'Artificial intelligence': 'artificialIntelligence',
  'Data science': 'dataScience',
  'Machine learning': 'machineLearning',
  Crypto: 'crypto',
  Scala: 'scala',
  Go: 'go',
  'Ux design': 'uxDesign',
  'Ui design': 'uiDesign',
  'Visual studio': 'visualStudio',
  '3d graphics': '3dGraphics',
  'Unity 3d': 'unity3d',
  'Graphic design': 'graphicDesign',
  Scrum: 'scrum',
  'Redux-saga': 'reduxSaga',
  'Next.js': 'next.js',
  Postgresql: 'postgresql',
  Mongodb: 'mongodb',
  Qa: 'qa',
  'Automation testing': 'automationTesting',
  'Python automation': 'pythonAutomation',
  'Bdd::Behavior-driven development': 'bddBehaviorDrivenDevelopment',
  'Mobile testing frameworks::Tools': 'mobileTestingFrameworksTools',
  Ruby: 'ruby',
  'Manual testing': 'manualTesting',
  'Objective-c': 'objectiveC',
  'Python for data science': 'pythonForDataScience',
  Hadoop: 'hadoop',
  Mvc: 'mvc',
  Mvvm: 'mvvm',
  Css: 'css',
  'Rest apis testing': 'restApisTesting',
  Oop: 'oop',
  'Software architecture': 'softwareArchitecture',
  Css3: 'css3',
  Html5: 'html5',
  'Adobe illustrator': 'adobeIllustrator',
  Apollo: 'apollo',
  Elasticsearch: 'elasticsearch',
  'Apache solr': 'apacheSolr',
  Linux: 'linux',
  Stripe: 'stripe',
  'Android::Java': 'androidJava',
  Http: 'http',
  Cplex: 'cplex',
  'Ci::Cd flows': 'ciCdFlows',
  Pandas: 'pandas',
  Numpy: 'numpy',
  'Api design': 'apiDesign',
  Roku: 'roku',
  'System design': 'systemDesign',
  Blockchain: 'blockchain',
  'Deep learning': 'deepLearning',
  Salesforce: 'salesforce',
  'Unit testing': 'unitTesting',
  'Tailwind css': 'tailwindCss',
  Springboot: 'springboot',
  'Core java': 'coreJava',
  Html: 'html',
  Elixir: 'elixir',
  Rabbitmq: 'rabbitmq',
  Kafka: 'kafka',
  Php: 'php',
  Uipath: 'uipath',
  'Aws amplify': 'awsAmplify',
  Accounting: 'accounting',
  Etl: 'etl',
  'Data pipelines': 'dataPipelines',
  Bash: 'bash',
  'Power bi': 'powerBi',
  'Data analyst': 'dataAnalyst',
  'Data analysis': 'dataAnalysis',
  Flux: 'flux',
  Rpa: 'rpa',
  'Back-end development': 'backEndDevelopment',
  Mocha: 'mocha',
  '.net core': '.netCore',
  'Ms sql server': 'msSqlServer',
  'Business analysis': 'businessAnalysis',
  'Web accessibility': 'webAccessibility',
  'Solution architecture': 'solutionArchitecture',
  'Apex programming': 'apexProgramming',
  'Mobile web development': 'mobileWebDevelopment',
  Alteryx: 'alteryx',
  Golang: 'golang',
  'Graph databases': 'graphDatabases',
  Tigergraph: 'tigergraph',
  'Ogma visualization library': 'ogmaVisualizationLibrary',
  Ios: 'ios',
  Sitecore: 'sitecore',
  'Asp.net::C#': 'asp.netC#',
  Selenium: 'selenium',
  Webdriver: 'webdriver',
  Testng: 'testng',
  Junit: 'junit',
  Mockito: 'mockito',
  Gradle: 'gradle',
  'Java 8': 'java8',
  Jenkins: 'jenkins',
  Saltstack: 'saltstack',
  'Spring framework': 'springFramework',
  'Apache kafka': 'apacheKafka',
  'Data warehousing': 'dataWarehousing',
  'Aws rds': 'awsRds',
  'Sap irpa v2': 'sapIrpaV2',
  'Sap irpa v1': 'sapIrpaV1',
  'Microsoft office': 'microsoftOffice',
  Autoit: 'autoit',
  'Jetpack compose': 'jetpackCompose',
  'Mobile app development': 'mobileAppDevelopment',
  'At least 1 year experience in customer service:: experience in a multi-client environment and has great work ethic:: strong computer aptitude':
    'atLeast1YearExperienceInCustomerServiceExperienceInAMultiClientEnvironmentAndHasGreatWorkEthicStrongComputerAptitude',
  'Which includes expertise with microsoft 365 applications:: strong organization':
    'whichIncludesExpertiseWithMicrosoft365ApplicationsStrongOrganization',
  'Oral and written communication skills:: analytical skills with particular attention to detail :: aptitude in data management':
    'oralAndWrittenCommunicationSkillsAnalyticalSkillsWithParticularAttentionToDetailAptitudeInDataManagement',
  'Reporting preparation:: ability to multi-task and function in an autonomous environmentindependent worker':
    'reportingPreparationAbilityToMultiTaskAndFunctionInAnAutonomousEnvironmentindependentWorker',
  'Self-directed.': 'selfDirected.',
  'Experience in the financial sector preferred:: solid customer service background:: at ease working with multiple computer programs and systems:: evidence of being a true team player and proven reliability in the workplace:: a positive attitude':
    'experienceInTheFinancialSectorPreferredSolidCustomerServiceBackgroundAtEaseWorkingWithMultipleComputerProgramsAndSystemsEvidenceOfBeingATrueTeamPlayerAndProvenReliabilityInTheWorkplaceAPositiveAttitude',
  'Heavy on motivation:: able to provide real-life examples of successful client relationships:: a proactive approach to problem-solving with meticulous attention to detail\na strong desire to succeed and an incredibly high level of patience:: excellent grasp of all microsoft 365 applications:: excellent verbal and written communication skills:: aptitude in data management':
    'heavyOnMotivationAbleToProvideRealLifeExamplesOfSuccessfulClientRelationshipsAProactiveApproachToProblemSolvingWithMeticulousAttentionToDetailAStrongDesireToSucceedAndAnIncrediblyHighLevelOfPatienceExcellentGraspOfAllMicrosoft365ApplicationsExcellentVerbalAndWrittenCommunicationSkillsAptitudeInDataManagement',
  'Analytics and reporting preparation:: ability to function in an autonomous environmentindependent worker':
    'analyticsAndReportingPreparationAbilityToFunctionInAnAutonomousEnvironmentindependentWorker',
  'Self-directed': 'selfDirected',
  'Requirement gathering': 'requirementGathering',
  Agile: 'agile',
  'Product management': 'productManagement_2',
  Grafana: 'grafana',
  Llm: 'llm',
  'Information technology': 'informationTechnology_2',
  'Technical writing': 'technicalWriting',
  'Azure databricks': 'azureDatabricks',
  'Computer vision': 'computerVision',
  'Azure data lake': 'azureDataLake',
  'Apache spark': 'apacheSpark',
  Unity: 'unity',
  'Azure synapse': 'azureSynapse',
  Espresso: 'espresso',
  Playwright: 'playwright',
  'Android studio': 'androidStudio',
  'Software development': 'softwareDevelopment_2',
  Openstack: 'openstack',
  Erp: 'erp',
  'Natural language processing (nlp)': 'naturalLanguageProcessingNlp',
  Webscrape: 'webscrape',
  Crawlers: 'crawlers',
  'Data extraction': 'dataExtraction',
  'R programming language': 'rProgrammingLanguage',
  Spark: 'spark',
  'Servicenow app engine': 'servicenowAppEngine',
  Shopify: 'shopify',
  'Cyber security': 'cyberSecurity',
  'Asp.net': 'asp.net',
  Snowflake: 'snowflake',
  'Dbt (data build tool)': 'dbtDataBuildTool',
  Airflow: 'airflow',
  'Android sdk': 'androidSdk',
  Dagger: 'dagger',
  'Sap abap': 'sapAbap',
  'Functional testing': 'functionalTesting',
  Sso: 'sso',
  Sketch: 'sketch',
  Pytorch: 'pytorch',
  Tensorflow: 'tensorflow',
  'Distributed systems': 'distributedSystems',
  Nosql: 'nosql',
  Leadership: 'leadership',
  'Amazon redshift': 'amazonRedshift',
  '3p apis & libraries': '3pApisLibraries',
  'Kotlin (for android)': 'kotlinForAndroid',
  'Salesforce admin': 'salesforceAdmin',
  'Salesforce development': 'salesforceDevelopment',
  'Css: animation': 'css:Animation',
  Postgis: 'postgis',
  'Html::Css': 'htmlCss',
  'Image recognition': 'imageRecognition',
  'Groovy on grails': 'groovyOnGrails',
  'Python(django)': 'pythonDjango',
  Sdlc: 'sdlc',
  Windchill: 'windchill',
  'Nuxt.js': 'nuxt.js',
  Nft: 'nft',
  'Aws devops': 'awsDevops',
  Communication: 'communication',
  'Fullstack development': 'fullstackDevelopment',
  'A::B testing': 'aBTesting',
  Cakephp: 'cakephp',
  Bootstrap: 'bootstrap',
  Rust: 'rust',
  'Software quality assurance': 'softwareQualityAssurance',
  'Integration testing': 'integrationTesting',
  'Load testing': 'loadTesting',
  Cassandra: 'cassandra',
  Keras: 'keras',
  Opencv: 'opencv',
  Spring: 'spring',
  'Struts 2': 'struts2',
  'Pwa::Progressive web applications': 'pwaProgressiveWebApplications',
  'Meteor.js': 'meteor.js',
  Xamarin: 'xamarin',
  Nginx: 'nginx',
  'Load balancing': 'loadBalancing',
  Lamp: 'lamp',
  'Swift (for ios)': 'swiftForIos',
  Electron: 'electron',
  'Data engineer': 'dataEngineer',
  Soap: 'soap',
  'Software testing': 'softwareTesting',
  'Algorithms and data structures': 'algorithmsAndDataStructures',
  Babel: 'babel',
  Sequelize: 'sequelize',
  'Web architecture': 'webArchitecture',
  'Growth engineering': 'growthEngineering',
  Ionic: 'ionic',
  'Java (for android)': 'javaForAndroid',
  'Spring mvc': 'springMvc',
  Magento: 'magento',
  'React hooks': 'reactHooks',
  Wordpress: 'wordpress',
  'Apache pulsar': 'apachePulsar',
  Web3: 'web3',
  'Website development': 'websiteDevelopment',
  Ssh: 'ssh',
  Access: 'access',
  Blender: 'blender',
  'Product design': 'productDesign',
  'E-commerce': 'eCommerce',
  Ethereum: 'ethereum',
  'Code analysis': 'codeAnalysis',
  'Database administration': 'databaseAdministration',
  'Data modeling': 'dataModeling',
  Sinatra: 'sinatra',
  'Aws solutions architecture': 'awsSolutionsArchitecture',
  Codeigniter: 'codeigniter',
  'Android hybrid app development': 'androidHybridAppDevelopment',
  Apache: 'apache',
  'Web design': 'webDesign',
  'Ant design': 'antDesign',
  'Ui development': 'uiDevelopment',
  'Websites performance optimization': 'websitesPerformanceOptimization',
  Swiftui: 'swiftui',
  Ec2: 'ec2',
  'Travis ci': 'travisCi',
  Celery: 'celery',
  'User-centered design': 'userCenteredDesign',
  'Npm packages development': 'npmPackagesDevelopment',
  Yarn: 'yarn',
  'Quantitative analysis': 'quantitativeAnalysis',
  'Deep learning algorithms': 'deepLearningAlgorithms',
  Odoo: 'odoo',
  'Embedded systems': 'embeddedSystems',
  Stm32: 'stm32',
  Smartcommunication: 'smartcommunication',
  'Windows apps development': 'windowsAppsDevelopment',
  Circleci: 'circleci',
  Drupal: 'drupal',
  Pmp: 'pmp',
  'Windows applications': 'windowsApplications',
  'Powershell scripting': 'powershellScripting',
  'Reporting and tracking software defects': 'reportingAndTrackingSoftwareDefects',
  'Wireframing & prototyping': 'wireframingPrototyping',
  'Material ui': 'materialUi',
  J2ee: 'j2ee',
  'Java jsf': 'javaJsf',
  Mvp: 'mvp',
  Video: 'video',
  'Php::Mysql': 'phpMysql',
  'Reporting services': 'reportingServices',
  '.net mvc': '.netMvc',
  Ipfs: 'ipfs',
  'Hl7 messages': 'hl7Messages',
  'Styled components': 'styledComponents',
  'Salesforce lightning': 'salesforceLightning',
  'Object-oriented design': 'objectOrientedDesign',
  'Ms sqlserver': 'msSqlserver',
  'Django rest framework': 'djangoRestFramework',
  'Clean architecture': 'cleanArchitecture',
  'Infrastructure operations': 'infrastructureOperations',
  'Angular cli': 'angularCli',
  'Aws cli': 'awsCli',
  'Aws iot': 'awsIot',
  Zookeeper: 'zookeeper',
  'Visual basic': 'visualBasic',
  'Db2 universal database (udb)': 'db2UniversalDatabaseUdb',
  Gatsby: 'gatsby',
  Auth0: 'auth0',
  Dns: 'dns',
  Nativescript: 'nativescript',
  'Arcgis javascript api': 'arcgisJavascriptApi',
  'Web sockets': 'webSockets',
  Neo4j: 'neo4j',
  'Feathers js': 'feathersJs',
  'Aws glue': 'awsGlue',
  Perl: 'perl',
  Gitlab: 'gitlab',
  'Windows sdk': 'windowsSdk',
  Symfony: 'symfony',
  'Elastic beanstalk': 'elasticBeanstalk',
  'Web components': 'webComponents',
  'Angular 2+': 'angular2+',
  'Data migration': 'dataMigration',
  'Shell scripting': 'shellScripting',
  Rxjs: 'rxjs',
  Cordova: 'cordova',
  'Entity framework': 'entityFramework',
  Qt: 'qt',
  'Big data': 'bigData',
  Dom: 'dom',
  'Micronaut framework': 'micronautFramework',
  Sqlalchemy: 'sqlalchemy',
  Devexpress: 'devexpress',
  Svelte: 'svelte',
  'Domain driven design': 'domainDrivenDesign',
  Pyspark: 'pyspark',
  'Asp.net core': 'asp.netCore',
  'Asp.net mvc': 'asp.netMvc',
  'Distributed file systems': 'distributedFileSystems',
  Rxswift: 'rxswift',
  'Api documentation': 'apiDocumentation',
  Vuex: 'vuex',
  Clojurescript: 'clojurescript',
  Rdbms: 'rdbms',
  Rtos: 'rtos',
  Prometheus: 'prometheus',
  Firewalls: 'firewalls',
  Puppeteer: 'puppeteer',
  'Elk stack': 'elkStack',
  'Scikit-learn': 'scikitLearn',
  'Network protocols': 'networkProtocols',
  Zeplin: 'zeplin',
  Mxnet: 'mxnet',
  Torch: 'torch',
  Caffe: 'caffe',
  Oracle: 'oracle',
  Xcode: 'xcode',
  'Cloud migration': 'cloudMigration',
  Maven: 'maven',
  Jee: 'jee',
  'Azure data factory': 'azureDataFactory',
  Rspec: 'rspec',
  'Magento 2': 'magento2',
  'Object-relational mapping': 'objectRelationalMapping',
  As3: 'as3',
  Pug: 'pug',
  'Oracle sql': 'oracleSql',
  'Electronic engineering and telecommunications': 'electronicEngineeringAndTelecommunications',
  'System monitoring tools': 'systemMonitoringTools',
  'Test planning': 'testPlanning',
  Bitbucket: 'bitbucket',
  'Selenium webdriver': 'seleniumWebdriver',
  'Tcp::Ip': 'tcpIp',
  'Azure devops': 'azureDevops',
  Splunk: 'splunk',
  'Oracle database administration': 'oracleDatabaseAdministration',
  'Erp development': 'erpDevelopment',
  Pyqt5: 'pyqt5',
  'Aws operations': 'awsOperations',
  Liquid: 'liquid',
  'Sound and audio': 'soundAndAudio',
  Unix: 'unix',
  Macos: 'macos',
  Sqlite: 'sqlite',
  'Game development': 'gameDevelopment',
  'System integration testing': 'systemIntegrationTesting',
  'Google api': 'googleApi',
  'Real time systems': 'realTimeSystems',
  Postman: 'postman',
  'Knockout.js': 'knockout.js',
  Multithreading: 'multithreading',
  Saas: 'saas',
  Vba: 'vba',
  'Play framework': 'playFramework',
  'Open source projects': 'openSourceProjects',
  Phpunit: 'phpunit',
  'Coldfusion cfml': 'coldfusionCfml',
  Adonisjs: 'adonisjs',
  Coldfusion: 'coldfusion',
  Odata: 'odata',
  Contentful: 'contentful',
  'Internal audit': 'internalAudit',
  'Electronic billing': 'electronicBilling',
  'Voice recognition': 'voiceRecognition',
  Confluence: 'confluence',
  Groovy: 'groovy',
  'Oracle fusion financial functional': 'oracleFusionFinancialFunctional',
  'Oracle erp': 'oracleErp',
  Boomi: 'boomi',
  Informatica: 'informatica',
  'Oracle pl::Sql': 'oraclePlSql',
  Subversion: 'subversion',
  Consul: 'consul',
  Oauth: 'oauth',
  Matlab: 'matlab',
  'Web penetration testing': 'webPenetrationTesting',
  'Salesforce lightning aura components': 'salesforceLightningAuraComponents',
  Servicenow: 'servicenow',
  'Industry: biotech': 'industry:Biotech',
  'Industry: pharmaceutical': 'industry:Pharmaceutical',
  'Reinforcement learning': 'reinforcementLearning',
  Robotics: 'robotics',
  'Cloud security': 'cloudSecurity',
  'Sas ml data science language': 'sasMlDataScienceLanguage',
  'Talend open studio': 'talendOpenStudio',
  'Sap hana sdi': 'sapHanaSdi',
  Atlassian: 'atlassian',
  Backbone: 'backbone',
  Scipy: 'scipy',
  'Android testing': 'androidTesting',
  'Azure cloud sql': 'azureCloudSql',
  'Linux tools': 'linuxTools',
  'Unix development environments': 'unixDevelopmentEnvironments',
  'Artificial neural networks': 'artificialNeuralNetworks',
  Spa: 'spa',
  Spacy: 'spacy',
  'Jupyter notebooks': 'jupyterNotebooks',
  Jwt: 'jwt',
  Xhtml: 'xhtml',
  'Google web toolkit': 'googleWebToolkit',
  'Aws cognito': 'awsCognito',
  Svg: 'svg',
  Stylus: 'stylus',
  Coffeescript: 'coffeescript',
  'Apache beam': 'apacheBeam',
  'Facebook api': 'facebookApi',
  'Virtual reality': 'virtualReality',
  'T-sql': 'tSql',
  'Digital marketing': 'digitalMarketing',
  Seo: 'seo',
  Grpc: 'grpc',
  'Opengl es': 'openglEs',
  'Problem solving': 'problemSolving',
  Tfs: 'tfs',
  Jdbc: 'jdbc',
  'Borland delphi': 'borlandDelphi',
  'Signal processing and transmission': 'signalProcessingAndTransmission',
  'Css: flex': 'css:Flex',
  'Dynamics 365 business central': 'dynamics365BusinessCentral',
  Aem: 'aem',
  Ssis: 'ssis',
  Graphene: 'graphene',
  'Filemaker development': 'filemakerDevelopment',
  'Regular expressions': 'regularExpressions',
  'Google apps': 'googleApps',
  Powerapps: 'powerapps',
  'Azure cosmos db': 'azureCosmosDb',
  'Aws administration': 'awsAdministration',
  Matplotlib: 'matplotlib',
  Plotly: 'plotly',
  Gwt: 'gwt',
  'Quasar framework': 'quasarFramework',
  'Code reviews': 'codeReviews',
  Akka: 'akka',
  Ssas: 'ssas',
  'Adobe xd': 'adobeXd',
  'Zend framework': 'zendFramework',
  'Amp (accelerated mobile pages)': 'ampAcceleratedMobilePages',
  Kendo: 'kendo',
  'Json schema': 'jsonSchema',
  'Twitter api': 'twitterApi',
  Optimization: 'optimization',
  'It officer': 'itOfficer',
  'Quality management': 'qualityManagement',
  Yaml: 'yaml',
  Recoil: 'recoil',
  'Automation test toolkit': 'automationTestToolkit',
  Composer: 'composer',
  Linq: 'linq',
  'Azure function app': 'azureFunctionApp',
  'Web workers': 'webWorkers',
  'Open gl': 'openGl',
  Teamcenter: 'teamcenter',
  Haskell: 'haskell',
  'Test driven design': 'testDrivenDesign',
  Erlang: 'erlang',
  'Design patterns': 'designPatterns',
  Lidar: 'lidar',
  Ssrs: 'ssrs',
  Chatbot: 'chatbot',
  Vmware: 'vmware',
  Ffmpeg: 'ffmpeg',
  'Acceptance testing': 'acceptanceTesting',
  'Excel vba': 'excelVba',
  'Windows services': 'windowsServices',
  Netsuite: 'netsuite',
  'Data cleansing': 'dataCleansing',
  Realm: 'realm',
  Gpt: 'gpt',
  'Open source': 'openSource',
  Iot: 'iot',
  'Css: grid': 'css:Grid',
  Hdfs: 'hdfs',
  Wpf: 'wpf',
  Reactivex: 'reactivex',
  Woocommerce: 'woocommerce',
  Highcharts: 'highcharts',
  Photoshop: 'photoshop',
  Braze: 'braze',
  Mixpanel: 'mixpanel',
  'Visual basic .net': 'visualBasic.net',
  Sap: 'sap',
  Axio: 'axio',
  'Aws aurora': 'awsAurora',
  'Asset management': 'assetManagement',
  'Hyperledger fabric': 'hyperledgerFabric',
  'Refinement of models': 'refinementOfModels',
  'E2e testing': 'e2eTesting',
  Openshift: 'openshift',
  'On-prem': 'onPrem',
  'Visual c++': 'visualC++',
  'Socket programming': 'socketProgramming',
  'Nw.js': 'nw.js',
  'Gcp appengine': 'gcpAppengine',
  'Open source frameworks': 'openSourceFrameworks',
  'Ejb component programming': 'ejbComponentProgramming',
  Gitflow: 'gitflow',
  'Computer science fundamentals': 'computerScienceFundamentals',
  'Aws iam': 'awsIam',
  'Css modules': 'cssModules',
  'Social media marketing': 'socialMediaMarketing',
  'Knex.js': 'knex.js',
  Webassembly: 'webassembly',
  Javascriptcore: 'javascriptcore',
  'Microsoft dynamics 365 ce': 'microsoftDynamics365Ce',
  'Angular 14': 'angular14',
  'Asp.net web forms': 'asp.netWebForms',
  Qlikview: 'qlikview',
  Saml: 'saml',
  Visualforce: 'visualforce',
  Sas: 'sas',
  'System admin': 'systemAdmin',
  Logstash: 'logstash',
  Elementor: 'elementor',
  'Service workers': 'serviceWorkers',
  'Adobe photoshop': 'adobePhotoshop',
  'Operating systems': 'operatingSystems',
  Routing: 'routing',
  Hipaa: 'hipaa',
  'Customer interaction': 'customerInteraction',
  'Business application development': 'businessApplicationDevelopment',
  Vagrant: 'vagrant',
  'Layer 2 networking': 'layer2Networking',
  Troubleshooting: 'troubleshooting',
  'Power platform development': 'powerPlatformDevelopment',
  'Prompt engineering': 'promptEngineering',
  'Apache nifi': 'apacheNifi',
  Xslt: 'xslt',
  'Aws emr': 'awsEmr',
  Jsp: 'jsp',
  'Stanford corenlp': 'stanfordCorenlp',
  'Azure eventhub': 'azureEventhub',
  'Data governance': 'dataGovernance',
  'Data management': 'dataManagement',
  'White hat link building': 'whiteHatLinkBuilding',
  'Electrical networks': 'electricalNetworks',
  Cisco: 'cisco',
  'Openai gym': 'openaiGym',
  'Ticketing tools': 'ticketingTools',
  Jamf: 'jamf',
  Polymer: 'polymer',
  'Business intelligence engineering': 'businessIntelligenceEngineering',
  'Mathematical modeling': 'mathematicalModeling',
  Obiee: 'obiee',
  'Oracle application dba': 'oracleApplicationDba',
  'Oracle adf': 'oracleAdf',
  'Ado.net': 'ado.net',
  'Crystal reports': 'crystalReports',
  Thrift: 'thrift',
  Invision: 'invision',
  Arduino: 'arduino',
  Lua: 'lua',
  Sapui5: 'sapui5',
  'Tigergraph. graph databases': 'tigergraph.GraphDatabases',
  'Adobe analytics': 'adobeAnalytics',
  'Functional testing or rest apis testing': 'functionalTestingOrRestApisTesting',
  Purview: 'purview',
  'Azure modern data': 'azureModernData',
  Asyncio: 'asyncio',
  'Spark (framework)': 'sparkFramework',
  'Aws lamda': 'awsLamda',
  'Microsoft dynamics nav': 'microsoftDynamicsNav',
  'Microsoft dynamics crm': 'microsoftDynamicsCrm',
  Fastapi: 'fastapi',
  Sfdc: 'sfdc',
  'analyste financier': 'analysteFinancier',
  'gouvernance de données': 'gouvernanceDeDonnées',
  'architecte de solution': 'architecteDeSolution',
  dba: 'dba',
  adf: 'adf',
  denodo: 'denodo',
  'BIG DATA': 'bigData_2',
  'architecte applicatif': 'architecteApplicatif',
  concepteur: 'concepteur',
  SNAPLOGIC: 'snaplogic',
  'architecte cloud': 'architecteCloud',
  iac: 'iac',
  'MARKIT EDM': 'markitEdm',
  pco: 'pco',
  actuariat: 'actuariat',
  actuarielle: 'actuarielle',
  cryptographie: 'cryptographie',
  "Architecte d'entreprise": 'architecteDEntreprise',
  'As per opening description': 'asPerOpeningDescription',
  IOS: 'ios_2',
  'Art::Creative': 'artCreative_2',
  'Financial services': 'financialServices',
  'Senior sqa engineer': 'seniorSqaEngineer',
  Webstocker: 'webstocker',
  'MDM IBM': 'mdmIbm',
  CBAP: 'cbap',
  nifi: 'nifi',
  '5 years pharmaceutical experience in clinical trials': '5YearsPharmaceuticalExperienceInClinicalTrials',
  'Analyst  ': 'analyst',
  Analytics: 'analytics',
  'At least 10 years of experience in the pharmaceutical industry':
    'atLeast10YearsOfExperienceInThePharmaceuticalIndustry',
  'Attention to detail': 'attentionToDetail',
  Attentive: 'attentive',
  AutoCAD: 'autocad',
  'Basketball player': 'basketballPlayer',
  'Biomarkers in nonclinical and clinical research': 'biomarkersInNonclinicalAndClinicalResearch',
  'BLA/NDA': 'blaNda',
  Budgeting: 'budgeting',
  C: 'c',
  'C++': 'c++',
  'CA BSIS guard card': 'caBsisGuardCard',
  'CAN architecture': 'canArchitecture',
  CAPA: 'capa',
  'Client Relationship Management': 'clientRelationshipManagement',
  'Clinical Leadership': 'clinicalLeadership',
  'Clinical study design': 'clinicalStudyDesign',
  'Cold calling': 'coldCalling',
  'Communication Skills': 'communicationSkills',
  'Comprehensive knowledge of ICH GCP Guidelines ': 'comprehensiveKnowledgeOfIchGcpGuidelines',
  'Content strategy': 'contentStrategy',
  'Contract negotiation': 'contractNegotiation',
  'Creative logic': 'creativeLogic',
  'CRF design': 'crfDesign',
  Curious: 'curious',
  Data: 'data',
  'Data Analysis': 'dataAnalysis',
  'Database management': 'databaseManagement',
  Economics: 'economics',
  'Electromechanical skillset': 'electromechanicalSkillset',
  'Email Marketing': 'emailMarketing',
  'Engineering Management': 'engineeringManagement',
  'English speaking': 'englishSpeaking',
  Entertainment: 'entertainment',
  Excel: 'excel',
  'Extensive knowledge and application of ALCOA+ standards': 'extensiveKnowledgeAndApplicationOfAlcoa+Standards',
  'Financial Modeling': 'financialModeling',
  'Financial Reporting': 'financialReporting',
  Firmware: 'firmware',
  Forecasting: 'forecasting',
  'FP&A': 'fp&a',
  'Future of Work': 'futureOfWork',
  GAAP: 'gaap',
  'GCP/GVP': 'gcpGvp',
  Gherkin: 'gherkin',
  "Global PRO's cue sheets": 'globalProsCueSheets',
  'Good Communicator': 'goodCommunicator',
  'Healthcare Management': 'healthcareManagement',
  Heroku: 'heroku',
  'HIL projects': 'hilProjects',
  Hiring: 'hiring',
  HRTech: 'hrtech',
  HTML: 'html',
  Hubspot: 'hubspot',
  IFRS: 'ifrs',
  'IND/CTA': 'indCta',
  Investor: 'investor',
  Jira: 'jira',
  JSOX: 'jsox',
  'Leadership and Team Building': 'leadershipAndTeamBuilding',
  'Lead generation': 'leadGeneration',
  'Lead Generation': 'leadGeneration',
  'Lean, Six Sigma experience': 'leanSixSigmaExperience',
  'loT security': 'lotSecurity',
  'MAM/Shared Storage/Archive environments': 'mamSharedStorageArchiveEnvironments',
  'Market Analysis': 'marketAnalysis',
  'Media Management': 'mediaManagement',
  'Microsoft Office': 'microsoftOffice',
  Modeling: 'modeling',
  'Negotiating ': 'negotiating',
  Negotiation: 'negotiation',
  'Open-minded': 'openMinded',
  Operations: 'operations',
  Organization: 'organization',
  'Organizational Skills': 'organizationalSkills',
  'Outbound sales': 'outboundSales',
  'Partnership Development': 'partnershipDevelopment',
  'Pharmaceutical Knowledge': 'pharmaceuticalKnowledge',
  'Policy Development': 'policyDevelopment',
  PowerBI: 'powerbi',
  Powerpoint: 'powerpoint',
  Pricing: 'pricing',
  'Problem-Solving': 'problemSolving',
  'Problem-Solving Abilities': 'problemSolvingAbilities',
  Procurement: 'procurement',
  'Product Presentation': 'productPresentation',
  'Product Support': 'productSupport',
  'Proficiency in Microsoft Office includes Microsoft Work, PowerPoint, Excel and 0-365':
    'proficiencyInMicrosoftOfficeIncludesMicrosoftWorkPowerpointExcelAnd0365',
  Prospecting: 'prospecting',
  'Public speaking': 'publicSpeaking',
  Python: 'python',
  'QA Management': 'qaManagement',
  'Qase Tool': 'qaseTool',
  'Quality Assurance and Improvement': 'qualityAssuranceAndImprovement',
  'Quality Control': 'qualityControl',
  R: 'r',
  'React.js': 'react.js',
  Recruiting: 'recruiting',
  'Relationship Building': 'relationshipBuilding',
  Reporting: 'reporting',
  Resilience: 'resilience',
  'REST APIs': 'restApis',
  'Ruby on rails': 'rubyOnRails',
  'Ruby on Rails': 'rubyOnRails',
  'Sales Acumen': 'salesAcumen',
  'Sales Strategy': 'salesStrategy',
  SAP: 'sap',
  Security: 'security',
  SQL: 'sql',
  'SQL Server': 'sqlServer',
  'Statistical models': 'statisticalModels',
  'Supplier management': 'supplierManagement',
  'Talent Acquisition': 'talentAcquisition',
  'Team Leadership': 'teamLeadership',
  'Team management': 'teamManagement',
  'Territory Management': 'territoryManagement',
  'Test Automation': 'testAutomation',
  'Test Cases': 'testCases',
  'Urban planning': 'urbanPlanning',
  'Vendor Management': 'vendorManagement',
  'Written/oral communication': 'writtenOralCommunication',
};
